import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isNil from "lodash/isNil";
import _get from "lodash/get";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import { ENTITY_TYPES, PRODUCT_TYPES, MONETIZATION_STATUSES } from '../../constants';
import { makeModuleDeprecationDecorator } from '../../utils/deprecation';
import * as autoLoansSelectors from '../auto-loans';
import * as bankingSelectors from '../banking';
import * as creditCardsSelectors from '../credit-cards';
import * as educationLoansSelectors from '../education-loans';
import * as estatePlanningSelectors from '../estate-planning';
import * as expansionSelectors from '../expansion';
import * as insuranceSelectors from '../insurance';
import * as investingSelectors from '../investing';
import * as mortgagesSelectors from '../mortgages';
import * as personalLoansSelectors from '../personal-loans';
import * as smbLoansSelectors from '../small-medium-business-loans';
import * as softwareSelectors from '../software';
import { callSelectorByEntityType, getInstitution, getCanonicalInstitutionType, getProduct, callSelectorByProductType } from './general-utils';
var withDeprecationWarning = makeModuleDeprecationDecorator('common');
/**
 * Gets Apply Now link url
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {String}                   Apply Now url
 */

export var getApplyLink = function getApplyLink(marketplaceEntity) {
  var _callSelectorByProduc;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc = {}, _defineProperty(_callSelectorByProduc, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getApplyLink), _defineProperty(_callSelectorByProduc, PRODUCT_TYPES.ESTATE_PLANNING, estatePlanningSelectors.getApplyLink), _defineProperty(_callSelectorByProduc, PRODUCT_TYPES.EXPANSION, expansionSelectors.getApplyLink), _defineProperty(_callSelectorByProduc, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getApplyLink), _callSelectorByProduc), function (entity) {
    return _get(entity, 'derived_details.apply_link.value');
  });
};
/**
 * Get the max APR.
 * @note LOANS SPECIFIC.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {number}                    The maximum APR.
 */

export var getAprMax = function getAprMax(marketplaceEntity) {
  var _callSelectorByProduc2;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc2 = {}, _defineProperty(_callSelectorByProduc2, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getAprMax), _defineProperty(_callSelectorByProduc2, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getAprMax), _defineProperty(_callSelectorByProduc2, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getAprMax), _callSelectorByProduc2));
};
/**
 * Get the min APR.
 * @note LOANS SPECIFIC.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {number}                    The minimum APR.
 */

export var getAprMin = function getAprMin(marketplaceEntity) {
  var _callSelectorByProduc3;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc3 = {}, _defineProperty(_callSelectorByProduc3, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getAprMin), _defineProperty(_callSelectorByProduc3, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getAprMin), _defineProperty(_callSelectorByProduc3, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getAprMin), _callSelectorByProduc3));
};
/**
 * Get bottom line content
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {String}                   "Bottom line" text
 */

export var getBottomLine = function getBottomLine(marketplaceEntity) {
  var _callSelectorByProduc4;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc4 = {}, _defineProperty(_callSelectorByProduc4, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getBottomLine), _defineProperty(_callSelectorByProduc4, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getBottomLine), _defineProperty(_callSelectorByProduc4, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getBottomLine), _defineProperty(_callSelectorByProduc4, PRODUCT_TYPES.INVESTING, investingSelectors.getBottomLine), _defineProperty(_callSelectorByProduc4, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getBottomLine), _defineProperty(_callSelectorByProduc4, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getBottomLine), _defineProperty(_callSelectorByProduc4, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getBottomLine), _callSelectorByProduc4));
};
/**
 * Get the "cons" bullets for an offer.
 *
 * @param   {Object} marketplaceEntity  The marketplaceEntity
 * @return  {Array}                     The "cons" array
 */

export var getConsBullets = function getConsBullets(marketplaceEntity) {
  var _callSelectorByProduc5;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc5 = {}, _defineProperty(_callSelectorByProduc5, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getConsBullets), _defineProperty(_callSelectorByProduc5, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getConsBullets), _defineProperty(_callSelectorByProduc5, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getConsBullets), _defineProperty(_callSelectorByProduc5, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getConsBullets), _defineProperty(_callSelectorByProduc5, PRODUCT_TYPES.INVESTING, investingSelectors.getConsBullets), _defineProperty(_callSelectorByProduc5, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getConsBullets), _defineProperty(_callSelectorByProduc5, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getConsBullets), _defineProperty(_callSelectorByProduc5, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getConsBullets), _callSelectorByProduc5));
};
/**
 * Get the cta text for an offer.
 *
 * @param   {Object} marketplaceEntity  The marketplaceEntity
 * @return  {string}                     The cta text
 */

export var getCtaText = function getCtaText(marketplaceEntity) {
  return callSelectorByProductType(marketplaceEntity, _defineProperty({}, PRODUCT_TYPES.SOFTWARE, softwareSelectors.getCtaText));
};
/**
 * Gets the created date of the entity
 *
 * @param {Object} marketplaceEntity The marketplace entity
 *
 * @return {number} Miliseconds since January 1, 1970
 */

export var getDateCreatedAt = function getDateCreatedAt(marketplaceEntity) {
  var secondsTimestamp = _get(marketplaceEntity, 'created_at');

  if (_isNil(secondsTimestamp)) return secondsTimestamp;
  return secondsTimestamp * 1000;
};
/**
 * Gets the last ingested date of the entity
 *
 * @param {Object} marketplaceEntity The marketplace entity
 *
 * @return {number} Miliseconds since January 1, 1970
 */

export var getDateLastIngestedAt = function getDateLastIngestedAt(marketplaceEntity) {
  var secondsTimestamp = _get(marketplaceEntity, 'details.last_ingested_at.value');

  if (_isNil(secondsTimestamp)) return secondsTimestamp;
  return secondsTimestamp * 1000;
};
/**
 * Gets the updated date of the entity
 *
 * @param {Object} marketplaceEntity The marketplace entity
 *
 * @return {number} Miliseconds since January 1, 1970
 */

export var getDateUpdatedAt = function getDateUpdatedAt(marketplaceEntity) {
  var secondsTimestamp = _get(marketplaceEntity, 'updated_at');

  if (_isNil(secondsTimestamp)) return secondsTimestamp;
  return secondsTimestamp * 1000;
};
/**
 * Gets flag to indicate if Apply links are disabled on editorial pages. When this is true, apply
 * links on editorial pages should be hidden or replaced with something else
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {boolean}                  disabled flag
 */

export var getDisableEditorialApplyLinkFlag = function getDisableEditorialApplyLinkFlag(marketplaceEntity) {
  return callSelectorByProductType(marketplaceEntity, _defineProperty({}, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getDisableEditorialApplyLinkFlag));
};
/**
 * Gets the disclaimer.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {string}                    The disclaimer text blob.
 */

export var getDisclaimer = function getDisclaimer(marketplaceEntity) {
  var _callSelectorByProduc8;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc8 = {}, _defineProperty(_callSelectorByProduc8, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getDisclaimer), _defineProperty(_callSelectorByProduc8, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getDisclaimer), _callSelectorByProduc8));
};
/**
 * Get the min FICO score.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {number}                    The minimum FICO score (0 indicates no min score).
 */

export var getFicoMin = function getFicoMin(marketplaceEntity) {
  var _callSelectorByProduc9;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc9 = {}, _defineProperty(_callSelectorByProduc9, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getFicoMin), _defineProperty(_callSelectorByProduc9, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getMinimumFICO), _defineProperty(_callSelectorByProduc9, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getMinFICO), _defineProperty(_callSelectorByProduc9, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getFicoMin), _defineProperty(_callSelectorByProduc9, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getFicoMin), _callSelectorByProduc9));
};
/**
 * Get the ID.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} The ID.
 */

export var getId = function getId(marketplaceEntity) {
  return _get(marketplaceEntity, 'id');
};
/**
 * Gets the alt text for the image associated with the offer
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {string}                   Alt text
 */

export var getImageAltText = function getImageAltText(marketplaceEntity) {
  var _callSelectorByProduc10;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc10 = {}, _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.BANKING, bankingSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.ESTATE_PLANNING, estatePlanningSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.EXPANSION, expansionSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.INVESTING, investingSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getImageAltText), _defineProperty(_callSelectorByProduc10, PRODUCT_TYPES.SOFTWARE, softwareSelectors.getImageAltText), _callSelectorByProduc10));
};
/*
 * Get the source URL of the image associated with the offer.
 *
 * @param      {Object}  marketplaceEntity  The marketplace entity
 * @param      {string}  size               Desired size of image, from constants.IMAGE_SIZES
 * @return     {string}  The URL of the image.
 */

export var getImageSrc = function getImageSrc(marketplaceEntity, size) {
  var _callSelectorByProduc11;

  return callSelectorByProductType([marketplaceEntity, size], (_callSelectorByProduc11 = {}, _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.BANKING, bankingSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.ESTATE_PLANNING, estatePlanningSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.EXPANSION, expansionSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.INVESTING, investingSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getImageSrc), _defineProperty(_callSelectorByProduc11, PRODUCT_TYPES.SOFTWARE, softwareSelectors.getImageSrc), _callSelectorByProduc11));
};
/**
 * Get whether or not the entity is monetizing.
 *
 * @param  {Object}  marketplaceEntity The marketplace entity.
 *
 * @return {boolean} If the entity is monetizing.
 */

export var getIsMonetizing = function getIsMonetizing(marketplaceEntity) {
  var _callSelectorByProduc12;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc12 = {}, _defineProperty(_callSelectorByProduc12, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getIsMonetizing), _defineProperty(_callSelectorByProduc12, PRODUCT_TYPES.BANKING, bankingSelectors.getIsMonetizing), _callSelectorByProduc12), function (entity) {
    return _get(entity, 'details.is_monetizing.value');
  });
};
/**
 * Get the issuer (to be used with the ApplyNow component).
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} Issuer name.
 */

export var getIssuerName = function getIssuerName(marketplaceEntity) {
  var _callSelectorByProduc13;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc13 = {}, _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.BANKING, bankingSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.ESTATE_PLANNING, estatePlanningSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.EXPANSION, expansionSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.INVESTING, investingSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getIssuerName), _defineProperty(_callSelectorByProduc13, PRODUCT_TYPES.SOFTWARE, softwareSelectors.getIssuerName), _callSelectorByProduc13));
};
/**
 * Get url to learn more page. Usually card details page for credit cards
 * or review page for other verticals
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} The get more link URL.
 */

export var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  var _callSelectorByProduc14;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc14 = {}, _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.BANKING, bankingSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.ESTATE_PLANNING, estatePlanningSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.EXPANSION, expansionSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.INVESTING, investingSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getLearnMoreLink), _defineProperty(_callSelectorByProduc14, PRODUCT_TYPES.SOFTWARE, softwareSelectors.getLearnMoreLink), _callSelectorByProduc14));
};
/**
 * Gets the legacy ID.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} The legacy ID.
 */

export var getLegacyId = function getLegacyId(marketplaceEntity) {
  var _callSelectorByProduc15;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc15 = {}, _defineProperty(_callSelectorByProduc15, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getLegacyId), _defineProperty(_callSelectorByProduc15, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getLegacyId), _defineProperty(_callSelectorByProduc15, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getLegacyId), _callSelectorByProduc15));
};
/**
 * Get the max loan amount.
 * @note LOANS SPECIFIC.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {number}                    The maximum loan amount.
 */

export var getLoanAmountMax = function getLoanAmountMax(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.max_loan_amount.value');
};
/**
 * Get the min loan amount.
 * @note LOANS SPECIFIC.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {number}                    The minimum loan amount.
 */

export var getLoanAmountMin = function getLoanAmountMin(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.min_loan_amount.value');
};
/**
 * Get the max loan term in months.
 * @note LOANS SPECIFIC.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {number}                    The maximum loan term in months.
 */

export var getLoanTermMax = function getLoanTermMax(marketplaceEntity) {
  var _callSelectorByProduc16;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc16 = {}, _defineProperty(_callSelectorByProduc16, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getLoanTermMax), _defineProperty(_callSelectorByProduc16, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getLoanTermMax), _callSelectorByProduc16));
};
/**
 * Get the min loan term in months.
 * @note PERSONAL LOANS SPECIFIC.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {number}                    The minimum loan term in months.
 */

export var getLoanTermMin = function getLoanTermMin(marketplaceEntity) {
  return callSelectorByProductType(marketplaceEntity, _defineProperty({}, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getLoanTermMin));
};
/**
 * Get whether or not the entity is monetizing.
 *
 * @param  {Object}  marketplaceEntity The marketplace entity.
 *
 * @return {boolean} If the entity is monetizing.
 */

export var getMonetizable = function getMonetizable(marketplaceEntity) {
  return _get(marketplaceEntity, 'derived_details.monetizable.value');
};
/**
 * Get the name to display for an offer.
 * @deprecated since 1.66.0 - Use `getDisplayName` or vertical specific selectors.
 *
 * @param      {Object}  marketplaceEntity  The marketplace entity
 * @return     {string}  The offer name.
 */

export var getName = withDeprecationWarning(function (marketplaceEntity) {
  var _callSelectorByProduc18;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc18 = {}, _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.BANKING, bankingSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.INVESTING, investingSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getName), _defineProperty(_callSelectorByProduc18, PRODUCT_TYPES.SOFTWARE, softwareSelectors.getName), _callSelectorByProduc18));
}, {
  name: 'getName',
  migration: 'Use `getDisplayName` instead. See https://github.com/NerdWallet/nwjs-marketplace/pull/108#discussion_r467241999 for more context.',
  version: '1.66.0'
});
/**
 * Get the name to display for a marketplaceEntity.
 *
 * @param {Object} marketplaceEntity - The marketplace entity.
 * @return {string} - The offer name.
 */

export var getDisplayName = function getDisplayName(marketplaceEntity) {
  var _callSelectorByProduc19;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc19 = {}, _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.BANKING, getProductName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.INVESTING, investingSelectors.getName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getName), _defineProperty(_callSelectorByProduc19, PRODUCT_TYPES.SOFTWARE, softwareSelectors.getName), _callSelectorByProduc19));
};
/**
 * Gets the offer if it exists.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} The offer.
 */

export var getOffer = function getOffer(marketplaceEntity) {
  return callSelectorByEntityType(marketplaceEntity, _defineProperty({}, ENTITY_TYPES.OFFERS, function () {
    return marketplaceEntity;
  }));
};
/**
 * Gets the ancestor product name.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} The ancestor product name.
 */

export var getProductName = function getProductName(marketplaceEntity) {
  return callSelectorByProductType(marketplaceEntity, _defineProperty({}, PRODUCT_TYPES.BANKING, bankingSelectors.getProductName));
};
/**
 * Get the "pros" bullets for an offer.
 *
 * @param   {Object} marketplaceEntity  The marketplaceEntity
 * @return  {Array}                     The "pros" array
 */

export var getProsBullets = function getProsBullets(marketplaceEntity) {
  var _callSelectorByProduc21;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc21 = {}, _defineProperty(_callSelectorByProduc21, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getProsBullets), _defineProperty(_callSelectorByProduc21, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getProsBullets), _defineProperty(_callSelectorByProduc21, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getProsBullets), _defineProperty(_callSelectorByProduc21, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getProsBullets), _defineProperty(_callSelectorByProduc21, PRODUCT_TYPES.INVESTING, investingSelectors.getProsBullets), _defineProperty(_callSelectorByProduc21, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getProsBullets), _defineProperty(_callSelectorByProduc21, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getProsBullets), _defineProperty(_callSelectorByProduc21, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getProsBullets), _callSelectorByProduc21));
};
/**
 * Get the qualifications bullets.
 *
 * @param   {Object} marketplaceEntity  The marketplace entity.
 * @return  {Array}                     The qualifications bullets.
 */

export var getQualificationsBullets = function getQualificationsBullets(marketplaceEntity) {
  var _callSelectorByProduc22;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc22 = {}, _defineProperty(_callSelectorByProduc22, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getQualificationsBullets), _defineProperty(_callSelectorByProduc22, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getQualificationsBullets), _defineProperty(_callSelectorByProduc22, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getQualificationsBullets), _defineProperty(_callSelectorByProduc22, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getQualificationsBullets), _callSelectorByProduc22));
};
/**
 * Get the slug for an offer.
 *
 * @param      {Object}  marketplaceEntity  The marketplace entity
 * @return     {string}  The offer slug.
 */

export var getSlug = function getSlug(marketplaceEntity) {
  var _callSelectorByProduc23;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc23 = {}, _defineProperty(_callSelectorByProduc23, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getSlug), _defineProperty(_callSelectorByProduc23, PRODUCT_TYPES.BANKING, bankingSelectors.getSlug), _defineProperty(_callSelectorByProduc23, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getSlug), _defineProperty(_callSelectorByProduc23, PRODUCT_TYPES.INVESTING, investingSelectors.getSlug), _defineProperty(_callSelectorByProduc23, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getSlug), _defineProperty(_callSelectorByProduc23, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getSlug), _defineProperty(_callSelectorByProduc23, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getSlug), _callSelectorByProduc23));
};
/**
 * Get the star rating.
 *
 * @param      {Object}  marketplaceEntity  The marketplace entity
 * @return     {number}  The star rating.
 */

export var getStarRating = function getStarRating(marketplaceEntity) {
  var _callSelectorByProduc24;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc24 = {}, _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.BANKING, bankingSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.INVESTING, investingSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.SMB_LOANS, smbLoansSelectors.getStarRating), _defineProperty(_callSelectorByProduc24, PRODUCT_TYPES.SOFTWARE, softwareSelectors.getStarRating), _callSelectorByProduc24));
};
/**
 * Get the star rating tooltip.
 *
 * @param      {Object}  marketplaceEntity  The marketplace entity
 * @return     {string}  The star rating tooltip.
 */

export var getStarRatingTooltip = function getStarRatingTooltip(marketplaceEntity) {
  var _callSelectorByProduc25;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc25 = {}, _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.BANKING, bankingSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.CREDIT_CARDS, creditCardsSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.ESTATE_PLANNING, estatePlanningSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.EXPANSION, expansionSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.INVESTING, investingSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.MORTGAGES, mortgagesSelectors.getStarRatingTooltip), _defineProperty(_callSelectorByProduc25, PRODUCT_TYPES.PERSONAL_LOANS, personalLoansSelectors.getStarRatingTooltip), _callSelectorByProduc25));
};
/**
 * Get the sub product type of a marketplace entity.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} Sub product type.
 */

export var getSubProductType = function getSubProductType(marketplaceEntity) {
  var _callSelectorByProduc26;

  return callSelectorByProductType(marketplaceEntity, (_callSelectorByProduc26 = {}, _defineProperty(_callSelectorByProduc26, PRODUCT_TYPES.AUTO_LOANS, autoLoansSelectors.getSubProductType), _defineProperty(_callSelectorByProduc26, PRODUCT_TYPES.BANKING, bankingSelectors.getSubProductType), _defineProperty(_callSelectorByProduc26, PRODUCT_TYPES.INVESTING, investingSelectors.getSubProductType), _defineProperty(_callSelectorByProduc26, PRODUCT_TYPES.EDUCATION_LOANS, educationLoansSelectors.getSubProductType), _defineProperty(_callSelectorByProduc26, PRODUCT_TYPES.INSURANCE, insuranceSelectors.getSubProductType), _callSelectorByProduc26));
};
/**
 * Get the version ID.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 * @return {number} The version ID.
 */

export var getVersionId = function getVersionId(marketplaceEntity) {
  return _get(marketplaceEntity, 'version_id');
};
/**
 * Get the id of the institution from the entity
 * @param {Object} marketplaceEntity
 */

export var getInstitutionId = function getInstitutionId(marketplaceEntity) {
  return getId(getInstitution(marketplaceEntity));
};
/**
 * Get the type of institution.
 * Does not work for Mortgage lender post!
 * @see {@link https://github.com/NerdWallet/nwjs-marketplace/blob/c3bbfb32e6a85077db9f67ded299253e569651f9/src/constants.js#L240-L269}
 *
 * @param {Object} marketplaceEntity - The marketplace enitty.
 * @return {String} - The canonical institution type.
 */

export var getInstitutionType = function getInstitutionType(marketplaceEntity) {
  return callSelectorByProductType(marketplaceEntity, _defineProperty({}, PRODUCT_TYPES.BANKING, bankingSelectors.getInstitutionType), getCanonicalInstitutionType);
};
/**
 * Get the id of the product from the entity
 * @param {Object} marketplaceEntity
 */

export var getProductId = function getProductId(marketplaceEntity) {
  return getId(getProduct(marketplaceEntity));
};
/**
 * Get the id of the offer from the entity
 * @param {Object} marketplaceEntity
 */

export var getOfferId = function getOfferId(marketplaceEntity) {
  return getId(getOffer(marketplaceEntity));
};
/**
 * Get the name of the institution from the entity
 * @param {Object} marketplaceEntity
 *
 * @return {String} - The name of the institution.
 */

export var getInstitutionName = function getInstitutionName(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'details.display_name.value');
};
/**
 * Gets filtered array of Best Of Awards with current year
 *
 * @param {Object} marketplaceEntity The marketplace entity
 *
 * @return {Array|undefined} - List of Best Of Awards for the current year
 */

export var getThisYearBestOfAwards = function getThisYearBestOfAwards(marketplaceEntity) {
  var _marketplaceEntity$de, _marketplaceEntity$de2, _marketplaceEntity$de3;

  return (_marketplaceEntity$de = marketplaceEntity.details) === null || _marketplaceEntity$de === void 0 ? void 0 : (_marketplaceEntity$de2 = _marketplaceEntity$de.best_of_awards) === null || _marketplaceEntity$de2 === void 0 ? void 0 : (_marketplaceEntity$de3 = _marketplaceEntity$de2.value) === null || _marketplaceEntity$de3 === void 0 ? void 0 : _marketplaceEntity$de3.filter(function (value) {
    return value.year === new Date().getFullYear().toString();
  });
};
/**
 * Returns true if a marketplaceEntity is non-monetizing.
 * If monetizable field exists, considers non-monetizing if the field is not yes_assumed.
 * Otherwise, consider an entity as non-monetizing only if the value is explicitly defined as false.
 * This ensures that we proceed with default behavior if the field is not defined in the entity.
 *
 * @param  {Object}  marketplaceEntity The marketplace entity
 *
 * @return {boolean}                   If the entity is non-monetizing
 */

export var isNonMonetizing = function isNonMonetizing(marketplaceEntity) {
  var monetizable = getMonetizable(marketplaceEntity);

  if (monetizable) {
    return monetizable !== MONETIZATION_STATUSES.YES_ASSUMED;
  }

  return getIsMonetizing(marketplaceEntity) === false;
};